export default __webpack_public_path__ + "200bac6a747854007f5a18dc32c1a501.png";